import videojs from "video.js";
import VideoLoading from "../VideoLoading";
import gsap from "gsap";

export default class SayHelloHero {
  static instance;

  constructor() {
    this.videoLoading = new VideoLoading();
    this.setupVideo();
    this.downArrowAnimation();
  }

  setupVideo() {
    this.player = videojs("say-hello-video-player");
    this.player.playsinline(true);
    this.player.controls(false);
    this.player.autoplay(false);
    this.player.muted(true);
    this.player.loop(true);
    this.player.preload(true);

    this.player.ready(() => {
      setTimeout(() => {
        this.videoLoading.completed();
        this.player.play();
      }, 3500);
    });
  }

  downArrowAnimation() {
    gsap.fromTo(
      ".down-arrow",
      { y: -10 },
      { y: 10, ease: Power0.easeInOut, duration: 0.4, repeat: -1, yoyo: true }
    );
  }
}
